const isValidPostcode = (postcode) => {
	const regex = /^[0-9]{7}$/;
	return regex.test(postcode);
}

const isValidHalfWidthKana = (kana) => {
	const regex = /^[ｦ-ﾟ ]+$/;
	return regex.test(kana);
}

const isValidPhoneNumber = (phoneNumber) => {
	const regex = /^[0-9\-]{10,14}$/;
	return regex.test(phoneNumber);
}

export { isValidPostcode, isValidHalfWidthKana, isValidPhoneNumber };